import React, { FC } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faClose } from "@fortawesome/pro-solid-svg-icons/faClose";
import { faQuestion } from "@fortawesome/pro-solid-svg-icons/faQuestion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, useIntl } from "react-intl";

import StatsBox, { StatsBoxProps } from "./StatsBox";

type StatsType = "completed" | "notStarted" | "partiallyComplete" | "unassigned";

const messages = defineMessages<StatsType>({
  completed: {
    id: "onboarding.users.userStats.completed",
    defaultMessage: "{icon} Completed",
    description: "Title of the Completed User stats box on the User Guides page",
  },
  notStarted: {
    id: "onboarding.users.userStats.notStarted",
    defaultMessage: "{icon} Not Started",
    description: "Title of the Not Started User stats box on the User Guides page",
  },
  partiallyComplete: {
    id: "onboarding.users.userStats.partiallyComplete",
    defaultMessage: "{icon} Partially Complete",
    description: "Title of the Partially Complete User stats box on the User Guides page",
  },
  unassigned: {
    id: "onboarding.users.userStats.unassigned",
    defaultMessage: "{icon} Unassigned",
    description: "Title of the Unassigned User stats box on the User Guides page",
  },
});

const typeToIcon: Readonly<Record<StatsType, IconProp>> = {
  completed: faCheck,
  notStarted: faClose,
  partiallyComplete: faClose,
  unassigned: faQuestion,
};

export interface UserStatsProps extends Omit<StatsBoxProps, "title" | "value"> {
  count: number;
  total: number;
  type: StatsType;
}

const UserStats: FC<UserStatsProps> = ({ count, total, type, ...props }) => {
  const intl = useIntl();
  return (
    <StatsBox
      {...props}
      title={intl.formatMessage(messages[type], {
        icon: <FontAwesomeIcon icon={typeToIcon[type]} />,
      })}
      value={intl.formatMessage(
        {
          id: "onboarding.guides.userStats.value",
          defaultMessage: "{count}/{total} {total, plural, one {user} other {users}}",
          description: "Value of User Stats on the Guides page",
        },
        { count, total }
      )}
    />
  );
};

export default UserStats;
